import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { USWDSLinkComponent } from './link.component';



@NgModule({
  declarations: [USWDSLinkComponent],
  imports: [
    CommonModule
  ],
  exports: [
    USWDSLinkComponent
  ]
})
export class USWDSLinkModule { }
